module.exports = __webpack_public_path__ + "img/5.f06a6d04.jpg";